import {configureStore} from "@reduxjs/toolkit";
import DeadManagementFiltersReducer from "./states/DeadManagementFiltersSlice"
import DeadManagementColumnsReducer from "./states/DeadManagementColumns";
export default configureStore({
    reducer: {
        deadManagementFilters:DeadManagementFiltersReducer,
        deadManagementColumns:DeadManagementColumnsReducer
    },
})